module.exports = __webpack_public_path__ + "static/assets/04783cef73a25a6393722a764dacc7d1.svg";